export function partialBuildLabel(set:{progress:unknown},savedCount:number):string {
 const target=(set.progress as {target?:number}|null)?.target;
 return Number.isSafeInteger(target) && target!>savedCount
  ? `Build ${savedCount} saved concept${savedCount===1?'':'s'} (of ${target} requested)`
  : 'Build Campaign';
}
